import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8AdMyVision from '../../components/A8/A8AdMyVision';
import CATEGORY_IMAGE from '../../../static/biz-professional/webdesign-4566239_1280.jpeg';
import { useNavigate } from 'react-router-dom';
import GL_IMAGE1 from '../../../static/biz-professional/GalleryLambda-Slide-ExecutiveSummaryExample.png';
import GL_IMAGE2 from '../../../static/biz-professional/GalleryLambda-Slide-ExecutiveSummaryTemplateSimple.png';
import GL_IMAGE3 from '../../../static/biz-professional/GalleryLambda-Slide-ExecutiveSummaryTemplateTrendy.png';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import A8Oisix from '../../components/A8/A8Oisix';
import A8Risap from '../../components/A8/A8Rizap';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            エグゼクティブサマリと世界で通用するテンプレ（第6回）
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Updated on 2024 Jan 24th <br />
                            15 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            これまで5回に渡り、プレゼンテーションのフォーマットや大事な考え方を説明してきました。プレゼンテーションにおけるイシュー、スライドの構成要素、トップメッセージの重要性、
                            みなさんはすでにこれらを理解していると思います。第5回からは中級レベルのテクニックを学びました。<br /><br />

                            第6回の今回は、エグゼクティブサマリー、（戦略コンサル業界における）通称エグザマ、についてです。<br /><br />

                            エグザマが書けるようになるとアナリスト（多くのファームにおける新卒1年目から3〜4年目までに与えられる役職）を卒業できる、なんて言われることもあります。
                            エグザマとは単にエグゼクティブレベルに向けた書く、ハイレベルにまとまったプレゼンテーションのサマリーです。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            エグゼクティブサマリーを作ろう（中級）
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px', fontWeight: 'lighter' }}>Table of Contents</Typography>
                    </CardContent>
                    <ol>
                        <li><a href="#1">エグゼクティブサマリーとは。</a></li>
                        <li><a href="#2">エグゼクティブ向けだけでない、その使い所。</a></li>
                        <li><a href="#3">最後に一言。</a></li>
                    </ol>
                    <Divider id="1" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>エグゼクティブサマリーとは。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            プレゼンテーション資料は、その目的によって、合計10ページ（スライド）であることもあるでしょうし、場合によっては100ページや200ページを超えるなんてこともあるかもしれません。
                            仮に1ページを読むのに30秒かかったとしても、10ページもあれば5分も要します。<br /><br />

                            5分を短いと捉えるか長いと捉えるのかに関しては意見は分かれるかもしれませんが、少なくともエグゼクティブを中心としたマネジメント層にとっては長い時間かもしれないですね。
                            そんな背景はさておき、プレゼンテーションの冒頭に、エグゼクティブサマリーと題して（単にサマリー/要旨などと書く場合もあります）、プレゼン全体のハイレベルなサマリーを1ページ程度で記載するのは極めて有効です。<br /><br />

                            単に忙しいエグゼクティブにサクッと読んでもらうため、という単純な目的ではありません。
                            エグザマの本質的な効果は、プレゼン全体を構造的にサマライズすることを通じて、ハイレベルなメッセージを着実に伝えることです。
                            <br /><br />
                            ここで実例も見てみましょう。
                            <CardMedia
                                component="img"
                                sx={{

                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE1}
                                alt="image of the category"
                            />
                            <br /><br />
                            解説していきましょう。まず、上記のエグザマでは「市場環境」「競争環境」「当市場における自社の事業展望」という3つのカテゴリに分けて各々でメッセージを出していますね。
                            ここでポイントはこのカテゴリは論点のカテゴリだということを覚えておきましょう。（もしスペースに余裕があれば、市場環境におけるトレンドは何か、などのように論点として記述する場合もあります。）
                            <br /><br />
                            次に、各々のカテゴリごとにメッセージを書いていますね。このメッセージ（上記のスライド例では3つありますね）はプレゼンテーションで伝えるべき最も重要なメッセージとなるように意識してください。
                            <br /><br />
                            最後に、各々のメッセージの下には、メッセージをサポートするような重要なファクトや背景が記載されます。とはいえ、エグザマではハイレベルな記載にとどめ、関連するページ番号を書いておくのが通例です。

                            <br /><br />
                            上記の例を抽象化して説明すると下記のテンプレートとなります。プレゼンテーションの要旨を説明する際には「論点」毎に「論点に対する答え・メッセージ」を記述し、
                            「そのメッセージを支える重要なファクトや示唆」を記述します。あくまでも要旨ですので、プレゼンテーション全体として伝えたいハイレベルな内容となるように意識しましょう。
                            是非、下記はテンプレートとしてご活用ください。
                            <CardMedia
                                component="img"
                                sx={{

                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE2}
                                alt="image of the category"
                            />
                            <br /><br />

                            さて、ここまで来たらエグザマのお作法は全て理解頂けたでしょう。テンプレートとしては上記のもので十分なのですが、少しお洒落にしたい場合は是非、下記をご参考に。
                            （なお、大企業の社長向けのプレゼンであったとしても、エグザマは上記の文章ベースが一般的ですので、下記はあくまでもお洒落さん向けのテンプレートです。）
                            <br /><br />
                            <CardMedia
                                component="img"
                                sx={{

                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE3}
                                alt="image of the category"
                            />

                            <br /><br />
                            <CardContent>
                                <A8Oisix />
                            </CardContent>

                            <br />
                            ここで、エグザマ作成におけるもっとも重要なコツ・ポイントをお伝えします。エグザマを作成する際は、そのプレゼンの目的がなんであれ、そのプレゼンの全体を通して伝えたいメッセージを3つ考えるところから始めてみてください。
                            （実際には、それが5つになっても大丈夫です。）
                            <br /><br />

                            上記は簡単に聞こえますが、実はとても難しい作業です。逆にいうと、プレゼン全体のメッセージを3つぱっと選べる人は、もうすでにプレゼンテーションの中級レベルに達していると言っていいでしょう。

                            <br /><br />
                            <CardContent>
                                <TipsAndUpdatesIcon /> 戦略コンサルティングファームであるA.T.Kearneyの公開資料のリンクを下記にご紹介します。p33ページにエグゼクティブサマリーがありますね。エグザマの具体的なイメージが湧いたかと思います。
                                <blockquote>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:METI <a href="https://www.meti.go.jp/shingikai/mono_info_service/new_cvs/pdf/004_02_00.pdf" target="_blank" rel="noopener noreferrer"> www.meti.go.jp </a> (p33) - A.T.Kearney
                                    </Typography>
                                </blockquote>
                            </CardContent>
                        </Typography>
                    </CardContent>



                    <Divider id="2" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>エグゼクティブ向けだけでない、その使い所。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            エグゼクティブサマリーというくらいですから、エグザマはエグゼクティブ向けなのではないかと思うかも知れませんが、それは大きな間違いです。<br /><br />

                            個人的には、全てのプレゼンにエグザマがあってもいい、と思っています。少なくとも、重要性が高いプレゼンテーションにおいてはエグザマは作成すべきです。

                            <br />
                            <br />
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>コラム - エグザマが書ける人、書けない人 </Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br /> 現場では非常に優秀な人と言われていてもエグザマが書けない人がいます。経験上、エグザマが書けるレベルに達しない限り、50人以上のマネジメントはできない方が多い気がします。<br /><br />
                                        そのような方々は、難しい事象を理解する能力に長けていても、それをシンプルな構造に落として説明する能力に欠けています。マネジメントする人数が多くなればなるほど、トップダウンな物事の見方が求められますから、
                                        マネジメント能力とエグザマ力が比例するのも納得です。<br /><br />

                                        とはいえ、ある程度トレーニングができる領域でもあるので、キャリアのなるべく早い段階でエグザマを書く習慣を身につけることが重要です。日々の業務でも実践してみてください。
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <A8Risap />
                    </CardContent>

                    <Divider id="4" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最後に一言</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            エグザマに関して、私が戦略コンサルティングファームに所属していた際に印象的だった出来事をご紹介したいと思います。
                            とある企業の買収の意思決定をすることが目的であるプロジェクトの最終報告会の冒頭にて、コンサル側のプロジェクトリーダーがエグゼクティブサマリーを読み上げます。なお、資料は全体で数百ページに渡ります。
                            エグゼクティブサマリーを読み終えた後、クライアント側の役員が質問をし始めます。15分くらいのディスカッションをしたでしょうか、その後その役員はすでに意思決定をしている様子でした。勿論、資料全体の説明も一部実施したものの、
                            エグザマを中心とした意思決定がなされたことが、（若手であった）当時は非常に驚きでした。それだけクリスタライズされた文章（メッセージ）だったのです。<br /><br />

                            第6回にわたって、種々のプレゼンスキルを説明してきましたが、改めて、プレゼンにおいて本質的に重要なことは、どれほどクリスタライズされたメッセージを出せるかどうかだと思います。
                            「結局のところ、あなたが言いたいことは何か - メッセージは何か」それを意識しながらプレゼンを作ると、きっといいものが出来上がるでしょう。
                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8AdMyVision />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
